import { render, staticRenderFns } from "./webPeriodSet.vue?vue&type=template&id=24c3280a&scoped=true"
import script from "./webPeriodSet.vue?vue&type=script&lang=js"
export * from "./webPeriodSet.vue?vue&type=script&lang=js"
import style0 from "./webPeriodSet.vue?vue&type=style&index=0&id=24c3280a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c3280a",
  null
  
)

export default component.exports